var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.b29f9f2a56bed7a0f94815536d136b9adee4154b2e0026e9ddf36bee5799ff54.svg#search';
                    var viewUrl = 'sprite.b29f9f2a56bed7a0f94815536d136b9adee4154b2e0026e9ddf36bee5799ff54.svg#view-search';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };